import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import React, { useCallback, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { BsLockFill, BsPersonFill } from 'react-icons/bs';

import { AxiosError } from 'axios';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import getValidationErrors from '../../utils/getValidationsErrors';

import Button from '../../components/Button';
import Input from '../../components/Input';

import logo from '../../assets/logo.png';

import { Background, Content } from './styles';

interface SignInFormData {
  email: string;
  password: string;
}

interface SignInProps {
  initialData?: SignInFormData;
}

const SignIn: React.FC<SignInProps> = ({ initialData }) => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const { addToast } = useToast();
  const { signIn } = useAuth();

  const [loading, setLoading] = useState(false);

  const submitHandler = useCallback(
    async (data: SignInFormData) => {
      setLoading(true);
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          email: Yup.string().required('E-mail obrigatório').email('Digite um e-mail válido'),
          password: Yup.string().required('Senha obrigatória'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await signIn({ email: data.email, password: data.password });

        return history.push('/app/dashboard');
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          return formRef.current?.setErrors(errors);
        }

        return addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: (error as AxiosError).response ? `${(error as AxiosError).response?.data.message}` : `${error}`,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, signIn, history],
  );

  return (
    <Background>
      <Content>
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>
        <Form ref={formRef} onSubmit={submitHandler} initialData={initialData}>
          <Input icon={BsPersonFill} color="#0C5C75" size={20} name="email" type="text" placeholder="Email" />
          <Input icon={BsLockFill} color="#0C5C75" size={20} name="password" type="password" placeholder="Senha" />

          <Link to="/forgot-password">Esqueci minha senha</Link>

          <Button name="login" isLoading={loading}>
            {loading ? 'autenticando...' : 'Entrar'}
          </Button>
        </Form>
      </Content>
      {/* <Link to="/admsignin" className="admPage">
        Entrar como
        <br />
        <strong>Administrador</strong>
      </Link> */}
    </Background>
  );
};
export default SignIn;
